import { Tooltip } from 'react-tooltip';
import { TRUNCATED_TOOLTIP_ID, useActiveTruncatedText } from './TruncatedTooltip';

/**
 * ✂️ 見切れ文字のツールチップ本体（アプリ全体で1個だけ置く）
 *
 * @description
 * 共通レイアウト(CommonLayout)に1個だけ配置する。data-tooltip-id が一致する全ての要素
 * (useTruncatedTooltip の tooltipProps を付けた要素)が対象で、見切れている要素にホバーした時だけ全文を出す。
 *
 * ⚠️ 行コンポーネントごとに <Tooltip> を置いてはいけない。
 * 同一idの Tooltip が行数N個になると、各 Tooltip が全行の対象要素へリスナーを付けにいくため
 * 処理量が N² になる（170件前後で画面が応答不可になった: P-0060）。
 */
export const TruncatedTooltipHost = () => {
  const text = useActiveTruncatedText();
  return (
    <Tooltip
      id={TRUNCATED_TOOLTIP_ID}
      className="!text-xs !z-[9999] !max-w-[350px] !break-words !whitespace-normal !bg-gray-800 !text-white !opacity-100 !px-3 !py-2 !rounded shadow-md"
      content={text || ""}
    />
  );
};
